import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import adminStore from '../../redux/adminStore';
import tokenStorage from "~/services/tokenStorage";

export const adminHttp = axios.create({
  baseURL: '/admin-api/',
});

export const ADMIN_AUTH_TOKEN = 'admin-authtoken';

createAuthRefreshInterceptor(adminHttp, () => {

    if (!tokenStorage.getItem(ADMIN_AUTH_TOKEN)) {
        return;
    }

    return adminHttp
        .post('/auth/refresh')
        .then((tokenRefreshResponse) => {

            let token = tokenRefreshResponse.data?.token;

            if (token) {
                tokenStorage.setItem(ADMIN_AUTH_TOKEN, token);
                return Promise.resolve();
            }

            throw new Error("Refresh failed!!");

        })
        .catch((err) => {
            tokenStorage.removeItem(ADMIN_AUTH_TOKEN);
            adminStore.dispatch({ type: 'LOGOUT' });
        });
});

adminHttp.interceptors.request.use((config) => {

    const token = tokenStorage.getItem(ADMIN_AUTH_TOKEN);

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});
